import { Navbar, Ourservices, Footer } from '../containers';

const Services = () => {
  return (
    <div>
        <div className="Services">
          <Navbar />
          <Ourservices />
          <Footer />
        </div>
    </div>
  )
}

export default Services